import React, { useState } from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { brand } from '../data/brand';
const shopLinks = [{
  label: 'Necklaces',
  href: '#chains'
}, {
  label: 'Earrings',
  href: '#studs'
}, {
  label: 'Bracelets',
  href: '#bracelets'
}, {
  label: 'Rings',
  href: '#rings'
}];
const supportLinks = [{
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Returns',
  href: '#faq-shipping-returns'
}, {
  label: 'Contact Us',
  href: '#contact'
}];
const legalLinks = [{
  label: 'Shipping & Returns',
  href: '#faq-shipping-returns'
}, {
  label: 'Privacy Policy',
  href: '#faq'
}, {
  label: 'Terms of Service',
  href: '#faq'
}];
export function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const handleSubscribe = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubscribed(true);
  };
  return <footer className="w-full border-t-2 border-gold bg-white" data-id="element-71" data-mp="2a1jlnfn4665m">
      <div className="mx-auto max-w-editorial px-6 py-14 md:px-12 md:py-20 lg:px-20" data-id="element-72" data-mp="2ez1nyn6mln4n">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-73" data-mp="3lalg1f31y5ty">
          <div data-id="element-74" data-mp="3gapcti26iifg">
            <img src={brand.logo} alt="ELORA Fine Jewelry — 18K Gold · New York" className="w-[220px] max-w-full object-contain mix-blend-multiply" data-id="element-75" data-mp="3gb8wp4be3gw4" />
            <p className="mt-5 max-w-xs font-sans text-[13px] font-light leading-relaxed text-maroon-soft" data-id="element-76" data-mp="3q7lnnufjvgn6">
              18K Gold and 18K Italian Gold jewelry, curated in New York and
              shipped nationwide.
            </p>
            <div className="mt-6 flex items-center gap-5" data-id="element-77" data-mp="33no2ai97rmt">
              <a href={brand.instagramHref} target="_blank" rel="noreferrer" aria-label={`Instagram ${brand.instagram}`} className="flex items-center gap-2 font-sans text-[12px] font-light text-maroon-soft transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-78" data-mp="ht3bbgiktexr">
                <InstagramIcon className="h-4 w-4 text-gold" strokeWidth={1.4} data-id="element-79" data-mp="tv4ng298r450" />
                {brand.instagram}
              </a>
            </div>
            <a href={`mailto:${brand.email}`} className="mt-3 flex items-center gap-2 font-sans text-[12px] font-light text-maroon-soft transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-80" data-mp="yuzec5t0ntq2">
              <MailIcon className="h-4 w-4 text-gold" strokeWidth={1.4} data-id="element-81" data-mp="18lu2jfptp3e5" />
              {brand.email}
            </a>
            <a href={brand.whatsappHref} target="_blank" rel="noreferrer" className="mt-3 block font-sans text-[12px] font-light text-maroon-soft transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-82" data-mp="1hkfgexkcnu8l">
              WhatsApp: {brand.phone}
              <span className="mt-0.5 block text-maroon-mute" data-id="element-83" data-mp="3obx1tcn86wuv">
                Assistance WhatsApp only
              </span>
            </a>
          </div>

          <nav aria-label="Shop" data-id="element-84" data-mp="3tc2wz2spf1hp">
            <h3 className="font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-85" data-mp="2afncncg8i20a">
              Shop
            </h3>
            <ul className="mt-5 space-y-3 font-sans text-[13px] font-light text-maroon-soft" data-id="element-86" data-mp="25nlsl4ctr6zp">
              {shopLinks.map(link => <li key={link.label} data-id="element-87" data-mp="21kflxvlsvdsp">
                  <a href={link.href} className="transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-88" data-mp="1woi7juu3khik">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Support" data-id="element-89" data-mp="2kci8fnl4hoav">
            <h3 className="font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-90" data-mp="2kbgjqgb6p3ao">
              Support
            </h3>
            <ul className="mt-5 space-y-3 font-sans text-[13px] font-light text-maroon-soft" data-id="element-91" data-mp="18y4naqhr7myj">
              {supportLinks.map(link => <li key={link.label} data-id="element-92" data-mp="13y042spgoe4m">
                  <a href={link.href} className="transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-93" data-mp="1414j6l4gsua2">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-94" data-mp="2isyfb9ia88og">
            <h3 className="font-sans text-[10px] uppercase tracking-luxe text-maroon-mute" data-id="element-95" data-mp="2it89zae9v40h">
              Newsletter
            </h3>
            <p className="mt-5 max-w-xs font-sans text-[13px] font-light leading-relaxed text-maroon-soft" data-id="element-96" data-mp="3bjgrd00zhke0">
              Enjoy 10% OFF on your first order when you contact us via email.
            </p>
            <form onSubmit={handleSubscribe} className="mt-5" data-id="element-97" data-mp="31mc2gsfr7ati">
              <label htmlFor="newsletter-email" className="sr-only" data-id="element-98" data-mp="36kne98plzved">
                E-mail
              </label>
              <input id="newsletter-email" name="email" type="email" required placeholder="E-mail" className="w-full border border-line bg-white px-4 py-3 font-sans text-[13px] font-light text-maroon outline-none transition-colors duration-150 ease-luxe placeholder:text-maroon-mute/60 focus:border-gold" data-id="element-99" data-mp="1q6nf3zyl89s6" />
              <button type="submit" className="mt-3 w-full bg-gold px-6 py-3.5 font-display text-[11px] font-light uppercase tracking-[0.3em] text-white transition-colors duration-150 ease-luxe hover:bg-gold-deep focus-visible:bg-gold-deep focus-visible:outline-none" data-id="element-100" data-mp="1wmw2b89mcsn1">
                Subscribe
              </button>
              <p role="status" aria-live="polite" className="mt-2 min-h-[1rem] font-sans text-[11px] font-light text-maroon-mute" data-id="element-101" data-mp="1dnrsvye60wuu">
                {subscribed ? 'Thank you for subscribing.' : ''}
              </p>
            </form>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-line pt-8 font-sans text-[11px] font-light text-maroon-mute sm:flex-row sm:items-center sm:justify-between" data-id="element-102" data-mp="g8xhtzn64gxg">
          <p data-id="element-103" data-mp="2l9qfpt89c5be">© {new Date().getFullYear()} ELORA Fine Jewelry. All rights reserved.</p>
          <ul className="flex flex-wrap items-center gap-6" data-id="element-104" data-mp="2l7dnmn8scekm">
            {legalLinks.map(link => <li key={link.label} data-id="element-105" data-mp="2q2t0bbv244fg">
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-106" data-mp="2uzt57jg6714z">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}